import { YourAppsMenu } from "../YourAppsMenu";
import { SignOutButton } from "../common/SignOutButton";
import { accountsPortal, centralEnabled } from '@/services/centralAuth'
import { BrandMark } from '../brand/BrandMark'
import { faArrowRightFromBracket, faUserShield } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Container, FormSelect, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { Link, NavLink } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { themeLabels, useTheme, type AppTheme } from '@/context/ThemeProvider'
import { BusinessSwitcher } from './BusinessSwitcher'
import { HubStatusPill } from './HubStatusPill'
import { NewOrderBadge, useNavItems } from './SideNav'

export function AdminHeader() {
  const { session, signOut, isDemo } = useAuth()
  const { theme, setTheme, availableThemes } = useTheme()
  const items = useNavItems()
  const name = session?.fullName?.trim() || session?.emailAddress || 'Signed in'

  return (
    <Navbar expand="lg" bg="light" className="shadow m-0 ps-2 pe-2 sticky-top" id="AdminMenu">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="admin-brand">
          <BrandMark />
          <span className="admin-brand__text">
            <strong>SmoothBadger CRM</strong>
            <small>Customer workspace</small>
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="mainNavContent" />
        <Navbar.Collapse id="mainNavContent">
          <Nav className="me-auto">
            {items.map((item) => (
              <Nav.Link key={item.to} as={NavLink} to={item.to} end={item.end} target={item.newTab ? '_blank' : undefined} rel={item.newTab ? 'noopener noreferrer' : undefined}>
                <FontAwesomeIcon icon={item.icon} /> {item.label}
                {item.to === '/orders' && <NewOrderBadge />}
              </Nav.Link>
            ))}
          </Nav>
          <Nav className="align-items-lg-center gap-lg-2">
            <BusinessSwitcher />
            {isDemo
              ? <span className="header-connection-pill header-connection-pill--demo"><span className="header-connection-pill__label">Demo</span></span>
              : <HubStatusPill />}
            <NavDropdown
              title={<span><FontAwesomeIcon icon={faUserShield} /> {name}</span>}
              id="nav-theme-menu"
              className="user-menu-dropdown"
              align="end"
            >
              {centralEnabled && !isDemo && <>
                <NavDropdown.Item href={`${accountsPortal}/profile?product=crm`} target="_blank" rel="noopener noreferrer">Your details</NavDropdown.Item>
                <NavDropdown.Item href={`${accountsPortal}/security?product=crm`} target="_blank" rel="noopener noreferrer">Password &amp; security</NavDropdown.Item>
                <NavDropdown.Divider />
              </>}
              {!isDemo && <YourAppsMenu current="crm" businessId={session?.businessId} />}
              <div className="user-menu-theme">
                <FormSelect
                  aria-label="Theme"
                  title="Theme selector"
                  value={theme}
                  onChange={(event) => setTheme(event.target.value as AppTheme)}
                >
                  {availableThemes.map((availableTheme) => (
                    <option key={availableTheme} value={availableTheme}>Theme: {themeLabels[availableTheme]}</option>
                  ))}
                </FormSelect>
              </div>
            </NavDropdown>
            <SignOutButton appName="CRM" variant="outline-secondary" onConfirm={signOut}>
              <FontAwesomeIcon icon={faArrowRightFromBracket} /> Sign out
            </SignOutButton>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
